import { Link } from "react-router-dom";
import { ArrowRight, Star } from "lucide-react";
import { useSettings } from "@/context/AppContext";
import PublicLayout from "@/components/PublicLayout";
import SmartImage from "@/components/SmartImage";
import ImageSkeleton from "@/components/ImageSkeleton";

export default function AboutPage() {
  const { settings, fresh } = useSettings();
  return (
    <PublicLayout>
      <section className="pt-36 pb-16 container-px max-w-7xl mx-auto">
        <p className="label-eyebrow mb-5">À propos</p>
        <h1 className="font-display text-5xl md:text-7xl text-forest font-light tracking-tight max-w-3xl leading-[0.95]">
          {settings?.about_title}
        </h1>
      </section>

      <section className="grid grid-cols-1 md:grid-cols-12 gap-10 container-px max-w-7xl mx-auto pb-24">
        <div className="md:col-span-7">
          <div className="aspect-[16/10] overflow-hidden">
            {fresh ? (
              settings?.about_image ? (
                <SmartImage src={settings.about_image} alt="Notre savoir-faire" className="w-full h-full" width={1400} eager />
              ) : (
                <div className="w-full h-full bg-bone" />
              )
            ) : (
              <ImageSkeleton className="w-full h-full" />
            )}
          </div>
        </div>
        <div className="md:col-span-5 md:pl-4">
          <p className="text-forest-soft leading-relaxed text-lg">{settings?.about_text}</p>
          <ul className="mt-10 space-y-4">
            {(settings?.about_values || []).map((v, i) => (
              <li key={i} className="flex items-start gap-3 border-b border-sand pb-4">
                <Star className="w-4 h-4 mt-1 text-corten fill-corten" />
                <span className="text-forest font-medium">{v}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="bg-forest text-cream py-24">
        <div className="container-px max-w-5xl mx-auto text-center">
          <h2 className="font-display text-4xl md:text-5xl font-light">
            Une approche durable et personnalisée.
          </h2>
          <p className="mt-6 text-cream/80 max-w-2xl mx-auto">
            Chaque jardin raconte une histoire. La nôtre commence par votre écoute, et se prolonge dans des finitions impeccables.
          </p>
          <Link to="/contact" className="inline-flex items-center gap-2 mt-10 btn-corten">
            {settings?.cta_label || "Demander un devis"} <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </section>
    </PublicLayout>
  );
}
